module.exports = __webpack_public_path__ + "img/2-3.e3ced587.png";